import styled from 'styled-components'

export const Item = styled.div`
    width: 100%;
    height: 110px;
    border-radius: 7px;
    border: 1px solid #e4e4e4;
    box-shadow: 0 1px 5px 0 rgb(121 128 139 / 22%);
    background-color: white;
    overflow: hidden;
    margin: 10px 0;
    display: flex;

    &:hover {
        box-shadow: none;
    }

    @media screen and (max-width: 1100px) {
        margin: 10px;
    }

    .item-header {
        width: 20%;
        display: flex;
        user-select: none;
        background-color: rgba(228,228,228,.22);
        overflow: hidden;
        border: none;
        outline: none;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .item-content {
        width: 60%;
        padding: 10px 20px;
        display: flex;
        flex-direction: column;

        > span {
            font-size: 1.4rem;
            font-weight: 500;
            margin: 5px 0 10px;
        }

        .tags {
            font-size: .7rem;
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            > span {
                display: flex;
                align-items: center;
                height: 18px;
                color: #1A3549dd;
                margin: 5px 15px 0 0;
            }
        }
    }

    .item-footer {
        width: 20%;
        background-color: rgba(228,228,228,.25);
        border-left: 1px solid #e4e4e4;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        flex-wrap: wrap;
        user-select: none;
        font-size: 1.3rem;
        color: #1A3549dd;

        i {
            cursor: pointer;
        }
    }
`
